<template>
  <div class="container" fluid>
    <b-modal
      scrollable
      id="editNews"
      @shown="loadData"
      @ok="editedNew"
      size="xl"
      title="Edit News"
      v-if="newEditArray"
    >
      <b-col>
        <b-row>
          <b-col>
            <h6>Title</h6>
            <b-form-textarea
              id="textarea"
              v-model="newEditArray.c_u_Title"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <h6>Resume</h6>
            <b-form-textarea
              id="textarea"
              v-model="newEditArray.c_u_Resume"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <h6>Image</h6>
            <b-container fluid class="border">
              <b-row>
                <b-col>
                  <img
                    style="padding: 5px"
                    :src="`${newEditArray.c_u_Image}`"
                    width="200"
                  />
                </b-col>
                <b-row>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    v-b-popover.hover.right="'Add other url'"
                  >
                    <fa icon="plus" size="sm" />
                  </b-button>
                </b-row>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <h6>Content</h6>
            <b-form-textarea
              id="textarea"
              v-model="newEditArray.c_u_Content"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-col>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "Edit News",

  data() {
    return {
      endpoint: "News",
      newEditArray: [],
    };
  },

  props: {
    newsEditId: Number,
  },

  components: {},
  watch: {},
  methods: {
    async loadData() {
      // parse xml to json
      this.$api.data.endpoint = this.endpoint;
      this.newEditArray = await this.$api.data.findOneById(this.newsEditId);

      this.$forceUpdate();
    },
    async editedNew(evt) {
      this.$api.data.endpoint = this.endpoint;
      await this.$api.data.updatedById(this.newsEditId, this.newEditArray);
      this.$emit("ok");
    },
  },

  mounted: function () {},
};
</script>
<style scoped>
p {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsEdit.vue